import { InfiniteData } from '@tanstack/react-query';
import { PaginatedData } from 'models/PaginatedData';

export function getNextPageParam<T>({
  currentPage,
  totalPages,
}: PaginatedData<T>) {
  if (currentPage < totalPages) return currentPage + 1;

  return undefined;
}

export function getInfiniteQueryItems<T>(
  data?: InfiniteData<PaginatedData<T>>,
) {
  return data?.pages.flatMap((page) => page.items) || [];
}

export function getInfiniteQueryTotalItems<T>(
  data?: InfiniteData<PaginatedData<T>>,
) {
  return data?.pages[0]?.totalItems || 0;
}
